module.exports = __webpack_public_path__ + "static/img/manual_ja_24.f219806.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_24.png
// module id = rr52
// module chunks = 4